export default function PatientInfo({ title, data }) {
  return (
    <tr>
      <td className="fw-bold">{title}</td>
      {data ? <td>{data}</td> : <td>N/A</td>}
    </tr>
  );
}
